export enum MaintenancePhase {
  Idle,
  // banner counts down to the deadline
  Countdown,
  // deadline passed with a round running; the page waits for `roundFinished`
  AwaitingRound,
  // the maintenance page replaced the game
  Active
}
